import { BasicProps, Footer } from "antd/es/layout/layout";
import { FC, RefAttributes } from "react";

export type IncFooterProps = BasicProps & RefAttributes<HTMLElement>;

export const IncFooter: FC<IncFooterProps> = (props) => <Footer {...props} />;
